import { render, staticRenderFns } from "./AcceptedItem.vue?vue&type=template&id=48d25abc&scoped=true&"
import script from "./AcceptedItem.vue?vue&type=script&lang=js&"
export * from "./AcceptedItem.vue?vue&type=script&lang=js&"
import style0 from "./AcceptedItem.vue?vue&type=style&index=0&id=48d25abc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d25abc",
  null
  
)

export default component.exports